module.exports = __webpack_public_path__ + "static/media/map-bg.bb1c4c05.png";